import { APIDirectory, HTTP } from "../../rest";
import { CreateAdminConstants } from '.'


export const createAdminInProgress = () => {
  return {
    type: CreateAdminConstants.CREATEADMIN_IN_PROGRESS
  };
};

export const createAdminComplete = data => {
  return {
    type: CreateAdminConstants.CREATEADMIN_COMPLETE,
    data: data
  };
};

export const createAdminFailure = (data) => {
  return {
    type: CreateAdminConstants.CREATEADMIN_FAILURE,
    data: data
  }
}

export const createAdminInServer = (ownerId, schoolId, userData) => {
  return async dispatch => {
    try {
      dispatch(createAdminInProgress());
      let url = APIDirectory.getAdminByOwnerIdAndSchoolId(ownerId, schoolId);
      let createAdminResult = await HTTP.POST(url, userData);
      dispatch(createAdminComplete(createAdminResult));
      return { createAdminResult: createAdminResult, status: true };
    } catch (error) {
      dispatch(createAdminFailure(error));
      return { createAdminResult: error, status: false };
    }
  };
};

export const fetchExistingAdmins = (schoolId) => {
  return async dispatch => {
    try {
      dispatch(fetchExistingAdminsInProgress());
      let url = APIDirectory.getExistingAdmins(schoolId);
      let response = await HTTP.GET(url);
      dispatch(fetchExistingAdminsSuccess(response));
      return response;
    }
    catch (error) {
      dispatch(fetchExistingAdminsfailure())
    }
  }
}

export const fetchExistingAdminsInProgress = () => {
  return {
    type: CreateAdminConstants.GET_EXISTING_ADMIN_IN_PROGRESS
  }
}

export const fetchExistingAdminsSuccess = (data) => {
  return {
    type: CreateAdminConstants.GET_EXISTING_ADMIN_SUCCESS,
    data
  }
}
export const fetchExistingAdminsfailure = () => {
  return {
    type: CreateAdminConstants.GET_EXISTING_ADMIN_FAILURE,
  }
}

export const deleteAdminProfileInProgress = () => {
  return {
    type: CreateAdminConstants.DELETE_ADMIN_IN_PROGRESS,
  }
}

export const deleteAdminProfileSuccess = (data) => {
  return {
    type: CreateAdminConstants.DELETE_ADMIN_SUCCESS,
    data: data
  }
}
export const deleteAdminProfileFialed = (data) => {
  return {
    type: CreateAdminConstants.DELETE_ADMIN_FAILED,
    data: data
  }
}
export const deleteAdminProfile = (userData, ownerId, schoolId) => {
  return async dispatch => {
    try {
      let userCognitoId = userData.cognitoId
      dispatch(deleteAdminProfileInProgress());
      let url = APIDirectory.getAdminByOwnerIdAndSchoolId(ownerId, schoolId);
      let updateProfileResult = await HTTP.PUT(url, userData);
      dispatch(deleteAdminProfileSuccess(updateProfileResult));
      return updateProfileResult;
    } catch (error) {
      dispatch(deleteAdminProfileFialed(error));
      //throw error
    }
  };
};